import { VideosWithoutApprovalTable } from "features/videoUploads/tables/VideosWithoutApprovalTable";
import "style/videoMetadataPage.css";
import { useEffect } from "react";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";

export function VideoUploadsNotSentPage() {
	useEffect(() => {
		setScrollBehavior();
	}, []);

	return (
		<div className="videoMetadataList-container">
			<div className="listHeadline">Not sent videos:</div>
			<VideosWithoutApprovalTable />
		</div>
	);
}
